export const CONFIGURE_APPROVAL_WORKFLOW_SETTINGS_ROUTE_PARAM_NAME = 'dealId';

/** Key the route resolver publishes the deal under, and the store reads it back from. */
export const CONFIGURE_APPROVAL_WORKFLOW_SETTINGS_ROUTE_RESOLVED_DEAL_KEY = 'deal';

export const CONFIGURE_APPROVAL_WORKFLOW_SETTINGS_TRANSLOCO_SCOPE = 'configure-approval-workflow-settings';

export const CONFIGURE_APPROVAL_WORKFLOW_SETTINGS_ROUTE_QUERY_PARAMS = {
  originPage: 'referrer',
};
